var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { HttpBooksApiV5Request } from './http-api-request.js';
export function createAccount(bookId, account, config) {
    return __awaiter(this, void 0, void 0, function* () {
        var response = yield new HttpBooksApiV5Request(`${bookId}/accounts`, config).setMethod('POST').setPayload(account).fetch();
        return response.data;
    });
}
export function createAccounts(bookId, payload, config) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        const response = yield new HttpBooksApiV5Request(`${bookId}/accounts/batch`, config).setMethod('POST').setPayload(payload).fetch();
        return ((_a = response.data) === null || _a === void 0 ? void 0 : _a.items) || [];
    });
}
export function updateAccount(bookId, account, config) {
    return __awaiter(this, void 0, void 0, function* () {
        var payload = account;
        var response = yield new HttpBooksApiV5Request(`${bookId}/accounts`, config).setMethod('PUT').setPayload(payload).fetch();
        return response.data;
    });
}
export function updateAccounts(bookId, payload, config) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        const response = yield new HttpBooksApiV5Request(`${bookId}/accounts/batch`, config).setMethod('PUT').setPayload(payload).fetch();
        return ((_a = response.data) === null || _a === void 0 ? void 0 : _a.items) || [];
    });
}
export function deleteAccount(bookId, account, config) {
    return __awaiter(this, void 0, void 0, function* () {
        var response = yield new HttpBooksApiV5Request(`${bookId}/accounts/${account.id}`, config).setMethod('DELETE').fetch();
        return response.data;
    });
}
export function deleteAccounts(bookId, payload, config) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        const response = yield new HttpBooksApiV5Request(`${bookId}/accounts/delete/batch`, config).setMethod('POST').setPayload(payload).fetch();
        return ((_a = response.data) === null || _a === void 0 ? void 0 : _a.items) || [];
    });
}
export function getAccount(bookId, idOrName, config) {
    return __awaiter(this, void 0, void 0, function* () {
        let response = yield new HttpBooksApiV5Request(`${bookId}/accounts/${encodeURIComponent(idOrName)}`, config).setMethod('GET').fetch();
        return response.data;
    });
}
export function getAccounts(bookId, config) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        let response = yield new HttpBooksApiV5Request(`${bookId}/accounts`, config).setMethod('GET').fetch();
        return ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.items) || [];
    });
}
//# sourceMappingURL=account-service.js.map